import { useRef } from "react";
import Select from "react-select";
import {
  getTemplateTypeDisplayValue,
  getTemplateTypes,
  isTemplateType,
  TemplateType,
} from "../../types/TemplateType";

export { TemplateTypeSelector, TemplateTypesSelector };

type Props = {
  /**
   * Restrict view to the following TemplateTypes.
   */
  whitelist?: TemplateType[];
  selected: TemplateType;
  onChange: (templateType: TemplateType) => void;
};

const DEFAULT_WHITELIST: TemplateType[] = ["NORMAL", "GENERAL", "FORMAT"];

const TemplateTypeSelector = (props: Props) => {
  const displayedTypes = Array.from(
    props.whitelist && props.whitelist.length
      ? props.whitelist
      : DEFAULT_WHITELIST,
  );
  if (!displayedTypes.includes("UNKNOWN") && props.selected === "UNKNOWN") {
    displayedTypes.push("UNKNOWN");
  }
  return (
    <select
      value={props.selected}
      onChange={(e) => {
        if (!isTemplateType(e.target.value)) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        props.onChange(e.target.value as TemplateType);
      }}
    >
      {displayedTypes
        .sort((a, b) => a.localeCompare(b))
        .map((type) => (
          <option
            key={type}
            value={type}
            // always disabled if unknown, otherwise disabled if not included in displayType
            // TODO: rename `displayTypes` to `selectTypes`
            disabled={
              type === "UNKNOWN" ? true : !displayedTypes.includes(type)
            }
            // TODO: use helper functions for labels
            label={getTemplateTypeDisplayValue(type as TemplateType)}
          >
            {/* use helper functions */}
            {getTemplateTypeDisplayValue(type as TemplateType)}
          </option>
        ))}
    </select>
  );
};

type PluralProps = {
  selected: TemplateType[] | undefined;
  onChange: (templateType: TemplateType[]) => void;
  includeUnknown?: boolean;
};

const TemplateTypesSelector = (props: PluralProps) => {
  const optionsRef = useRef([
    { value: "FORMAT", label: getTemplateTypeDisplayValue("FORMAT") },
    { value: "GENERAL", label: getTemplateTypeDisplayValue("GENERAL") },
    { value: "NORMAL", label: getTemplateTypeDisplayValue("NORMAL") },
    // { value: 'UNKNOWN', label: getTemplateTypeDisplayValue('UNKNOWN') },
  ] as { value: string; label: string }[]).current;

  const displayedTypes: TemplateType[] = DEFAULT_WHITELIST;
  if (props.includeUnknown) {
    displayedTypes.push("UNKNOWN");
  }

  const selected = optionsRef.filter((o) =>
    props.selected?.includes(o.value as TemplateType),
  );

  return (
    <Select
      defaultValue={selected}
      onChange={(x) => {
        props.onChange(x.map((x) => x.value as TemplateType));
      }}
      isMulti
      name="Template Types"
      options={optionsRef}
      className="basic-multi-select"
      classNamePrefix="select"
    />
  );
};
